import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AppBarContext from '../components/BusinessPortalAppBarContext';
import DashboardContext from '../modules/Dashboard/DashboardContext';
import DashboardView from '../modules/Dashboard/DashboardView';

const DashboardPage = () => {
  const appBarContext = useContext(AppBarContext);

  useEffect(() => {
    appBarContext.setAppBar(true);
    appBarContext.setPeriodSelector(true);
  });

  const { search } = useLocation();
  const queryString = new URLSearchParams(search);

  return (
    <DashboardContext urlString={queryString}>
      <DashboardView />
    </DashboardContext>
  );
};

export default DashboardPage;
